module.exports = __webpack_public_path__ + "img/5.c6fd4c9b.png";